import React from 'react';
import { useCart } from '../../context/CartContext';
import './ProductCard.css';

const ProductCard = ({ product, featured = false, onProductClick, animationDelay }) => {
  const { addToCart } = useCart();

  const handleAddToCart = (e) => {
    e.stopPropagation();
    addToCart(product);
  };

  const handleCardClick = () => {
    if (product.productId && onProductClick) {
      onProductClick(product.productId);
    }
  };

  return (
    <div 
      className={`product-card ${featured ? 'featured' : ''} ${product.productId ? 'clickable' : ''}`}
      onClick={handleCardClick}
      style={animationDelay ? { animationDelay } : {}}
    >
      <div className="product-image-container">
        <img 
          src={product.image} 
          alt={product.name}
          className="product-image"
          loading="lazy"
        />
        <div className="product-overlay">
          {product.productId ? (
            <button 
              className="view-details-btn"
              aria-label={`View details for ${product.name}`}
            >
              View Details
            </button>
          ) : (
            <button 
              className="add-to-cart-btn"
              onClick={handleAddToCart}
              aria-label={`Add ${product.name} to cart`}
            >
            </button>
          )}
        </div>
      </div>
      
      <div className="product-info">
        <h3 className="product-name">{product.name}</h3>
        {featured && product.description && (
          <p className="product-description">{product.description}</p>
        )}
        {product.category && (
          <span className="product-category">{product.category}</span>
        )}
      </div>
    </div>
  );
};

export default ProductCard;